const route = {
	path: ':subsidiaryId/:subsidiaryName/:periodId/accounting-action',
	name: 'page-accounting-action',
	meta: {
		title: 'Contabilización',
	},
	component: () => import('@/pages/accounting-periods/page-accouting-action'),
	props: true,
};

export default route;



// WEBPACK FOOTER //
// ./src/router/accouting-action.js